import { Box, IconButton, Menu } from "@mui/material";
import React, { useState } from "react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import EmojiIcon from "src/components/pages/chat/ChatContainer/InboxAndMessageBox/MessageBox/ChatBox/BottomBar/icons/emoji";

interface Props {
  onEmojiClick: any;
  color?: string;
  activeColor?: string;
}

const EmojiPicker: React.FC<Props> = ({
  onEmojiClick,
  color = "black",
  activeColor = "#4d1277",
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleanchorE1Open = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleanchorE1Open} sx={{ m: 0, p: 0 }}>
        <EmojiIcon color={anchorEl ? activeColor : color} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
            border: "1px solid rgba(0,0,0,0.05)",
            overflow: "hidden",
            marginTop: "-10px",
          },
        }}
      >
        <Box sx={{ height: 430, width: 350 }}>
          <Picker
            theme="light"
            set="native"
            data={data}
            onEmojiSelect={(emoji: any) => {
              onEmojiClick(emoji);
              handleMenuClose();
            }}
            icons="outline"
            navPosition="bottom"
            previewPosition="none"
          />
        </Box>
      </Menu>
    </>
  );
};

export default EmojiPicker;
